import { useState } from 'react'
import { Menu, X } from 'lucide-react'
import { profile } from '../data/profile'

const navItems = [
  ['About', 'about'],
  ['Research', 'research'],
  ['Projects', 'projects'],
  ['Experience', 'experience'],
  ['Publications', 'publications'],
  ['Certificates', 'certificates'],
  ['Resume', 'resume'],
  ['Contact', 'contact']
]

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => setIsOpen(false)

  return (
    <header className="sticky top-0 z-50 border-b border-academic-line bg-academic-bg/88 backdrop-blur-xl">
      <nav className="section-shell flex h-20 items-center justify-between" aria-label="Main navigation">
        <a href="#hero" className="text-sm font-bold tracking-tight text-academic-text md:text-base">
          {profile.name}
        </a>

        <div className="hidden items-center gap-6 lg:flex">
          {navItems.map(([label, id]) => (
            <a
              key={id}
              href={`#${id}`}
              className="text-sm font-medium text-academic-muted transition hover:text-academic-blue"
            >
              {label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label="Open navigation menu"
          onClick={() => setIsOpen((value) => !value)}
          className="inline-flex rounded-full border border-academic-line bg-white p-2 text-academic-text lg:hidden"
        >
          {isOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {isOpen && (
        <div className="border-t border-academic-line bg-academic-bg lg:hidden">
          <div className="section-shell grid gap-1 py-4">
            {navItems.map(([label, id]) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={handleClick}
                className="rounded-xl px-3 py-3 text-sm font-medium text-academic-muted transition hover:bg-white hover:text-academic-blue"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
